"use client";

import { Card, CardContent } from "@/components/ui/card";
export default function ServiceDetails() {
  return <section id="service-details" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <Card className="border-border-strong border-2 shadow-none rounded-none bg-background p-0">
          <CardContent className="p-8 md:p-12">
            <h2 className="text-3xl md:text-4xl font-display font-bold mb-6 text-foreground text-center">
              Our Clinical Approach
            </h2>
            <p className="text-lg md:text-xl text-foreground leading-relaxed text-center">
              At Axion Physiotherapy, we provide expert care for sports injuries, back and neck pain, post-operative rehabilitation, and workplace-related conditions. Our evidence-based approach ensures that every patient receives a personalized treatment plan tailored to their specific needs and goals, delivered in a professional and friendly clinical environment. We focus on providing clear, jargon-free explanations and effective recovery pathways for active adults and office workers.
            </p>
          </CardContent>
        </Card>
      </div>
    </section>;
}